module.exports = __webpack_public_path__ + "img/moon-5.e7221dfe.svg";